import { useTranslation } from 'react-i18next';
import { gql, useMutation } from '@apollo/client';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

const UPDATE_GANTT_ABSENCE_RECORD = gql`
  mutation updateRecordAbsence($payload: UpdateAbsenceToRecordEntryInput!) {
    updateRecordAbsence(payload: $payload) {
      type
      conflicts
    }
  }
`;

export const useUpdateGanttAbsenceRecord = ({ onSuccess }: { onSuccess: (value: any) => void }) => {
  const { t } = useTranslation('common');
  const [updateGanttAbsenceRecord] = useMutation(UPDATE_GANTT_ABSENCE_RECORD, {
    onCompleted: onSuccess,
    onError: (error: any) =>
      showNotification({
        type: NOTIFICATION_TYPE.error,
        message: t('notifications.error.title'),
        ...(error && { description: error.message || error.errorMessage }),
      }),
  });

  return updateGanttAbsenceRecord;
};
